module.exports = __webpack_public_path__ + "img/Move-In_Logo.7a2b1540.png";